import { Tour } from "antd";
import { useEffect } from "react";
import { useRaidTourStore } from "./raidTourStore";
import { getStepsForContext } from "./tourSteps";
import { RaidTourLauncher } from "./RaidTourLauncher";
import { raidTourStore } from "./raidTourStore";

const CTX = "raid-list" as const;
const AUTO_START_DELAY = 600;

export function RaidListTour() {
  const { activeContext, close } = useRaidTourStore();

  useEffect(() => {
    const { hasSeen, start } = raidTourStore.getState();
    if (hasSeen(CTX)) return;
    const timer = window.setTimeout(() => {
      if (!raidTourStore.getState().hasSeen(CTX)) start(CTX);
    }, AUTO_START_DELAY);
    return () => clearTimeout(timer);
  }, []);

  const isOpen = activeContext === CTX;
  const steps = getStepsForContext(CTX);

  return (
    <>
      <Tour open={isOpen} steps={steps} onClose={close} onFinish={close} />
      <RaidTourLauncher context={CTX} />
    </>
  );
}
